module.exports = __webpack_public_path__ + "static/media/boomreader-logo-full.13c2ffce.svg";